export const TAB_USERS = 'users'
export const TAB_MESSAGING = 'messaging'
export const TAB_T1_INVITATIONS = 't1ReviewerInvitations'
export const TAB_T1_REMINDERS = 't1ReviewerReminder'
export const TAB_T2_INVITATIONS = 't2ReviewerInvitations'
export const TAB_T2_REMINDERS = 't2ReviewerReminder'
export const TAB_T2_INVITATION = 't2UserInvitations'
export const TAB_T2_REMINDER = 't2UserReminder'
export const TAB_T1_REPORT = 't1UserReport'
export const TAB_T2_REPORT = 't2UserReport'

export const T1 = 't1'
export const T2 = 't2'

export const REVIEW_TYPES = {
  T1,
  T2,
}

export const SUPERIOR = 'Superior'
export const PEER = 'Peer'
export const EMPLOYEE = 'Employee'

export const T1_SUPERIOR = `${T1}${SUPERIOR}`
export const T1_PEER = `${T1}${PEER}`
export const T1_EMPLOYEE = `${T1}${EMPLOYEE}`
export const T2_SUPERIOR = `${T2}${SUPERIOR}`
export const T2_PEER = `${T2}${PEER}`
export const T2_EMPLOYEE = `${T2}${EMPLOYEE}`

export const SCOPE_REVIEWS = 'reviews'

export const subTabs = [
  {
    title: 'Users',
    value: TAB_USERS,
  },
  {
    title: 'Messaging',
    value: TAB_MESSAGING,
  },
]

export const subTabsMessaging = [
  {
    title: 'Reviewer T1 Invitations',
    value: TAB_T1_INVITATIONS,
  },
  {
    title: 'Reviewer T1 Reminders',
    value: TAB_T1_REMINDERS,
  },
  {
    title: 'Reviewer T2 Invitations',
    value: TAB_T2_INVITATIONS,
  },
  {
    title: 'Reviewer T2 Reminders',
    value: TAB_T2_REMINDERS,
  },
  {
    title: 'User T2 Invitation',
    value: TAB_T2_INVITATION,
  },
  {
    title: 'User T2 Reminder',
    value: TAB_T2_REMINDER,
  },
  {
    title: 'User T1 Report',
    value: TAB_T1_REPORT,
  },
  {
    title: 'User T2 Report',
    value: TAB_T2_REPORT,
  },
]

export const STATUS_FILTER = {
  INCOMPLETE_OTHER_REVIEWS_T1: 'incompleteOtherReviewsT1',
  INCOMPLETE_OTHER_REVIEWS_T2: 'incompleteOtherReviewsT2',
  INCOMPLETE_SELF_REVIEW_T2: 'incompleteSelfReviewT2',
  INCOMPLETE_SELF_REVIEW_T2_SEND_INVITATION: 'incompleteSelfReviewT2SendInvitation',
  INCOMPLETE_SELF_REVIEW_T2_SEND_REMINDER: 'incompleteSelfReviewT2SendReminder',
  T1_READY: 't1Ready',
  T2_READY: 't2Ready',
  ALL: 'all',
}

export const headerCells = [
  {
    field: 'fullName',
    title: 'Full Name',
    sortable: true,
  },
  {
    field: 'email',
    title: 'Email',
    sortable: true,
  },
  {
    field: 'teams',
    title: 'Teams',
    sortable: false,
  },
  {
    field: 't1Self',
    title: 'T1 Self',
    sortable: false,
  },
  {
    field: T1_SUPERIOR,
    title: 'T1 Superior',
    sortable: false,
  },
  {
    field: T1_PEER,
    title: 'T1 Peer',
    sortable: false,
  },
  {
    field: T1_EMPLOYEE,
    title: 'T1 Employee',
    sortable: false,
  },
  {
    field: 't2Self',
    title: 'T2 Self',
    sortable: false,
  },
  {
    field: T2_SUPERIOR,
    title: 'T2 Superior',
    sortable: false,
  },
  {
    field: T2_PEER,
    title: 'T2 Peer',
    sortable: false,
  },
  {
    field: T2_EMPLOYEE,
    title: 'T2 Employee',
    sortable: false,
  },
  {
    title: '',
    field: 'actions',
    right: true,
  },
]

export const ADD_REVIEWERS_FORM = 'addReviewersForm'
